import { Button, Popover, PopoverProps } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

import '../global.less';
import './kebabmenu.scss';

export const KebabMenu = ({ children, ...rest }: PopoverProps) => {
    return (
        <Popover
            className="rain-kebab-menu"
            overlayClassName="rain-kebab-menu-inner"
            trigger="click"
            content={children}
            {...rest}>
            <Button className="rain-kebab-button" type="text" icon={<FontAwesomeIcon icon={faEllipsisV} />}></Button>
        </Popover>
    );
};

export default KebabMenu;
